import React from "react";
import { Transition, Header, Container, Segment } from "semantic-ui-react";
import Busquedas from "./inicio/Busquedas";

class Inicio extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState({ visible: true });
  }
  componentWillUnmount() {
    this.setState({ visible: false });
  }

  render() {
    return (
      <Container>
        <Segment basic padded textAlign="center">
          <Transition.Group animation="scale" duration={150}>
            {this.state.visible && (
              <Header inverted as="h1">
                Actividades Extraescolares
              </Header>
            )}
          </Transition.Group>
          <Segment basic>
            <Busquedas />
          </Segment>
        </Segment>
      </Container>
    );
  }
}
export default Inicio;



// WEBPACK FOOTER //
// ./src/pages/Inicio.jsx